module.exports = __webpack_public_path__ + "img/memes-spiderman1.de0871af.webp";